import React, { useEffect, useState } from "react";
import DropdownMenu from "../components/DropdownMenu";
import { Constants } from "../libs/Constants";
import { getDefaultPeriodSelection } from "../libs/periodLib";
import { constructPeriodForDisplay } from "../libs/utils";
const periodSelectionOptions = [
  {
    key: Constants.PURCHASE_PERIOD_DISPLAY_TYPES.PURCHASE,
    value: Constants.PURCHASE_PERIOD_DISPLAY_TYPES.PURCHASE,
    children: [],
  },
  {
    key: Constants.PERIOD_DISPLAY_TYPES.CONTRIBUTION,
    value: Constants.PERIOD_DISPLAY_TYPES.CONTRIBUTION,
    children: [],
  },
];
const PeriodDropdown = (props) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [periodDropdown, setPeriodDropdown] = useState({
    fieldName: "periodSelected",
    type: "dropdown",
    options: [],
  });
  useEffect(() => {
    function load() {
      if (props.periods && props.periods.length > 0 && props.plan) {
        populatePeriodFilter();
        setDefaultPeriod();
      }
    }
    load();
  }, [props.periods, props.plan]);

  function populatePeriodFilter() {
    let options = [];
    if (props.options) {
      options = props.options;
    } else {
      options = periodSelectionOptions;
    }
    if (props.periods && props.periods.length > 0) {
      let periodType = options.find(
        (option) =>
          option.key === Constants.PURCHASE_PERIOD_DISPLAY_TYPES.PURCHASE
      );
      if (periodType) {
        let optionIndex = options.indexOf(periodType);
        options[optionIndex].children = props.periods.map((period) => {
          return {
            itemKey: "" + period.periodStartdate,
            type: Constants.PERIOD_DISPLAY_TYPES.PURCHASE,
            title: constructPeriodForDisplay(
              period,
              props.activeCompany?.timezone
            ),
          };
        });
      }
      let contributionType = options.find(
        (option) => option.key === Constants.PERIOD_DISPLAY_TYPES.CONTRIBUTION
      );
      if (contributionType) {
        let optionIndex = options.indexOf(contributionType);
        //Now we know we have ateast one period
        let totalTranche = getTotalTranch();
        let totalOfferingPeriod = props.periods.length - totalTranche + 1;
        options[optionIndex].children = [];
        for (let i = 0; i < totalOfferingPeriod; i++) {
          let offeringPeriod = {
            itemKey: "" + props.periods[i].periodStartdate,
            type: Constants.PERIOD_DISPLAY_TYPES.CONTRIBUTION,
            title: constructPeriodForDisplay(
              props.periods[i],
              props.activeCompany?.timezone
            ),
          };
          options[optionIndex].children.push(offeringPeriod);
        }
      }
      setPeriodDropdown(Object.assign(periodDropdown, { options }));
    }
  }
  function getTotalTranch() {
    let trancheCount =
      Number(props.plan.lookBack) / Number(props.plan.purchasePeriod);
    return trancheCount;
  }

  // this function is used for default selection
  function setDefaultPeriod() {
    let periodResponse = getDefaultPeriodSelection(props.periods);
    if (periodResponse) {
      handlePeriodSelect({
        type: Constants.PERIOD_DISPLAY_TYPES.PURCHASE,
        itemKey: periodResponse.currentPeriod.periodStartdate,
      });
    }
  }

  async function handlePeriodSelect(e) {
    let selectedPeriod = props.periods.find(
      (p) => p.periodStartdate === parseInt(e.itemKey)
    );
    let period = { type: e.type, period: selectedPeriod };
    setSelectedPeriod(period);
    if (props.handlePeriodSelect) {
      props.handlePeriodSelect(period);
    }
  }

  function getTitle() {
    if (selectedPeriod?.period) {
      return constructPeriodForDisplay(selectedPeriod?.period);
    }
    return "";
  }
  return (
    <div className="me-3 mb-3">
      <DropdownMenu
        open={openMenu}
        onClick={(e) => {
          handlePeriodSelect(e);
        }}
        onClose={() => {
          setOpenMenu(false);
        }}
        onOpen={() => {
          setOpenMenu(true);
        }}
        topKey="selectedPeriod"
        config={[
          {
            title: getTitle(),
            itemKey: "selectedPeriod",
            submenu: periodDropdown.options.map((f) => ({
              title: f.value,
              itemKey: f.key,
              submenu: f.children,
            })),
          },
        ]}
      />
    </div>
  );
};

export default PeriodDropdown;
